import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tooltip, Breadcrumb as ZenBreacrumb } from '@zenlayer/zen-design';
import qs from 'query-string';
import { useEffect, useMemo, useState } from 'react';
import { Copy } from './copy';
import cls from './index.module.less';
import { generateBreadcrumbs, traversalRoutes } from './util';
import '@zenlayer/zen-design-icons/assets/HomeOutlined.svg';
import '@zenlayer/zen-design-icons/assets/general/ConnectOn.svg';
import { pickDomAttrs } from '@zenlayer/zen-design/esm/_util/utils';
import { HomeBread, ToolTipDelaySecond } from './helper/home-bread';
const BreacrumbItem = ZenBreacrumb.Item;
export const Breadcrumb = ({ hideHome = false, separator = '/', routes = [], labelIndex, urlHref = location.href, copyable = false, disableCopyFullScreen, addition, customBreads, }) => {
    const { pathname, origin, search, hash } = useMemo(() => {
        return new URL(urlHref);
    }, [urlHref]);
    const [routesMap, setRoutesMap] = useState({});
    const _search = search.replace(/^\?+/, '?');
    const copyUrl = useMemo(() => {
        const copyUrl = new URL(`${origin}${pathname}${_search}${hash}`);
        disableCopyFullScreen || copyUrl.searchParams.set('full_screen', 'true');
        return copyUrl;
    }, [urlHref]);
    useEffect(() => {
        setRoutesMap((prev) => {
            return {
                ...prev,
                ...traversalRoutes(routes, {
                    containParentPath: true,
                    labelIndex: labelIndex || 'label',
                }),
            };
        });
    }, [routes]);
    console.log({ routes, routesMap });
    const breadCrumbs = useMemo(() => {
        const breads = customBreads?.length
            ? customBreads
            : generateBreadcrumbs(pathname, routesMap);
        // if addition_route exist add a fake bread for detail drawer
        const searchObj = qs.parse(_search);
        if (searchObj?.addition_route && addition) {
            const lastBread = breads[breads.length ? breads.length - 1 : 0];
            return [
                ...breads,
                {
                    ...lastBread,
                    path: lastBread?.path,
                    content: searchObj?.addition_name || addition?.routeName,
                },
            ];
        }
        return breads;
    }, [pathname, routesMap, _search, addition?.routeName, customBreads]);
    return (_jsxs("div", { className: cls.container, children: [_jsxs(ZenBreacrumb, { separator: separator ? separator : '/', children: [hideHome ? null : _jsx(HomeBread, {}), breadCrumbs.map((item, key) => {
                        const isLast = breadCrumbs.length - 1 == key;
                        const attrs = pickDomAttrs(item);
                        return (_createElement(BreacrumbItem, { ...attrs.data, className: 'bread-item', key: key, href: isLast ? undefined : item.currentPath },
                            _jsx(Tooltip, { title: item.content, mouseEnterDelay: ToolTipDelaySecond, children: item.content })));
                    })] }), copyable ? _jsx(Copy, { copyUrl: copyUrl.toString() }) : null] }));
};
